import { useCallback, useState } from 'react'

import { type CatalogPermissionUserConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionUserConfig'

export const useCatalogUserAccessSection = () => {
  const [selectedUser, setSelectedUser] =
    useState<Nullable<CatalogPermissionUserConfig>>(null)

  const selectedUserId = selectedUser?.id ?? null

  const onSelectUser = useCallback((user: CatalogPermissionUserConfig) => {
    setSelectedUser(user)
  }, [])

  const onCancel = useCallback(() => {
    setSelectedUser(null)
  }, [])

  return {
    states: {
      selectedUser,
      selectedUserId,
    },
    commands: {
      onSelectUser,
      onCancel,
    },
  }
}
